import { render, staticRenderFns } from "./DetailOrderList.vue?vue&type=template&id=750ad3a0&scoped=true&"
import script from "./DetailOrderList.vue?vue&type=script&lang=js&"
export * from "./DetailOrderList.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrderList.vue?vue&type=style&index=0&id=750ad3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750ad3a0",
  null
  
)

export default component.exports